import React from "react";
import NavButton from "./NavButton";
import { IoGrid, IoGridOutline } from "react-icons/io5";

interface CoursesButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const CoursesButton: React.FC<CoursesButtonProps> = ({ isActive, onClick }) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      // iOS ref: square.grid.2x2 / square.grid.2x2.fill (_layout.tsx:44).
      // IoGrid is a 2x2 grid of rounded squares — the closest react-icons
      // match to the SF Symbol. (Was MdVideoLibrary, which did not match.)
      icon={<IoGridOutline className="h-full w-auto" />}
      fillIcon={<IoGrid className="h-full w-auto" />}
      text="Courses"
    />
  );
};

export default CoursesButton;
